export function addViewAllNewsButton(url, label) {
	const tabButtonsContainer = document.getElementById("actionsMenu");

	// Create a custom node for dynamically added button
	const tabButtonsNode = document.createElement("div");
	tabButtonsNode.setAttribute("id", "tabButtons");
	tabButtonsNode.classList.add("tab-buttons");

	const link = createLink(url, label);
	tabButtonsNode.appendChild(link);
	tabButtonsContainer.appendChild(tabButtonsNode);

	addNewsListAllNewsLink(url, label);

	function addNewsListAllNewsLink(url, label) {
		const newsList = document.querySelectorAll(".tab-pane > .news-list");
		newsList?.forEach((newsList) => {
			const newsListLink = createLink(url, label);
			newsList.appendChild(newsListLink);
		});
	}

	function createLink() {
		const link = document.createElement("a");
		link.classList.add(
			"btn",
			"btn--primary",
			"btn--has-icon__mobile",
			"btn--news",
		);
		link.setAttribute("href", url);
		const content = document.createElement("span");
		content.innerText = label;
		link.appendChild(content);
		return link;
	}
}
